import { getApiKey } from "../providers/api-key.provider";

interface UploadPhotoResult {
  uploadProgress: Ref<number>;
  finished: Ref<boolean>;
  loading: Ref<boolean>;
  uploadedUrl: Ref<string>;
  reset: () => void;
  upload: (file: Blob) => void;
}

export const photos = {
  useUploadPhoto: (
    onUploadedCallback?: (url: string) => void,
  ): UploadPhotoResult => {
    const finished = ref(false);
    const uploadProgress = ref(0);
    const uploadedUrl = ref("");
    const loading = ref(false);

    const config = useRuntimeConfig();

    const reset = () => {
      finished.value = false;
      uploadProgress.value = 0;
      uploadedUrl.value = "";
      loading.value = false;
    };

    const upload = async (file: Blob) => {
      loading.value = true;

      const formData = new FormData();

      formData.append("image", file);

      uploadProgress.value = 50;

      const headers = new Headers();
      headers.set("Authorization", `Bearer ${getApiKey()}`);

      const responseData = await $fetch<{ url: string }>("photo", {
        baseURL: config.public.apiBaseUrl,
        method: "POST",
        headers,
        body: formData,
        parseResponse: JSON.parse,
      });

      uploadProgress.value = 100;
      uploadedUrl.value = responseData.url;

      finished.value = true;
      loading.value = false;

      if (onUploadedCallback) onUploadedCallback(uploadedUrl.value);
    };

    return {
      finished,
      uploadProgress,
      uploadedUrl,
      upload,
      loading,
      reset,
    };
  },
};
